module.exports = __webpack_public_path__ + "img/banner-5k.cbfca85a.svg";